(function () {

  var FEE_VARIANT_ID = window.serviceFeeVariantId;
  var TRIGGER_IDS    = window.feeTriggerIds || [];

  if (!FEE_VARIANT_ID || !TRIGGER_IDS.length) return;

  // ─── Cart API helpers ───────────────────────────────────────────────────────

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function cartHasFee(cart) {
    return cart.items.some(function (item) {
      return item.variant_id === FEE_VARIANT_ID;
    });
  }

  function cartHasTriggerProduct(cart) {
    return cart.items.some(function (item) {
      return item.variant_id !== FEE_VARIANT_ID
          && TRIGGER_IDS.indexOf(item.variant_id) !== -1;
    });
  }

  function addFee() {
    return fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: [{ id: FEE_VARIANT_ID, quantity: 1 }] })
    });
  }

  function removeFee(cart) {
    var feeItem = cart.items.find(function (item) {
      return item.variant_id === FEE_VARIANT_ID;
    });
    if (!feeItem) return Promise.resolve();
    return fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: feeItem.key, quantity: 0 })
    });
  }

  function enforceFeeQuantity(cart) {
    var feeItem = cart.items.find(function (item) {
      return item.variant_id === FEE_VARIANT_ID;
    });
    if (feeItem && feeItem.quantity > 1) {
      return fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: feeItem.key, quantity: 1 })
      });
    }
    return Promise.resolve();
  }

  // ─── Sync logic ─────────────────────────────────────────────────────────────

  var syncing     = false;
  var pendingSync = false;
  var selfRefresh = false;

  function doSync() {
    return getCart().then(function (cart) {
      var hasFee     = cartHasFee(cart);
      var hasTrigger = cartHasTriggerProduct(cart);

      if (hasTrigger && !hasFee) {
        return addFee().then(function () {
          selfRefresh = true;
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        });
      } else if (!hasTrigger && hasFee) {
        return removeFee(cart).then(function () {
          selfRefresh = true;
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        });
      } else if (hasTrigger && hasFee) {
        return enforceFeeQuantity(cart);
      }

      return Promise.resolve();
    });
  }

  function syncServiceFee() {
    if (syncing) {
      pendingSync = true;
      return;
    }
    syncing = true;

    doSync()
      .catch(function (err) {
        console.warn('Service fee sync failed:', err);
      })
      .then(function () {
        syncing = false;
        if (pendingSync) {
          pendingSync = false;
          setTimeout(syncServiceFee, 150);
        }
      });
  }

  function syncWithDelay(ms) {
    setTimeout(syncServiceFee, ms || 0);
  }

  // ─── Event listeners ────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', syncServiceFee);

  document.addEventListener('cart:updated', function () {
    syncWithDelay(300);
  });

  document.addEventListener('dispatch:cart-drawer:open', function () {
    syncWithDelay(300);
  });

  document.addEventListener('dispatch:cart-drawer:refresh', function () {
    if (selfRefresh) {
      selfRefresh = false;
      return;
    }
    syncWithDelay(500);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncServiceFee, 600);
    });

    observer.observe(cartDrawer, { childList: true, subtree: true });
  });

})();
